import { useAuth0 } from '@auth0/auth0-react';
import { useParams } from 'react-router';
import useSWR, { SWRResponse } from 'swr';
import { AISearchCountResponse, DefaultAISearchCountResponse } from './DTO/AISearchCountResponse';
import http from '@/Utils/HTTP/NewHttpUtils';

const useAISearchCounters = (): SWRResponse<AISearchCountResponse> => {
    const { getAccessTokenSilently } = useAuth0();
    const { assessmentId } = useParams();

    return useSWR(`recruitments/${assessmentId}/ai-search/counters`, async (path) => {
        const response = await http.get<AISearchCountResponse>({
            path,
            accessToken: await getAccessTokenSilently(),
        });

        return response || DefaultAISearchCountResponse;
    });
};

export default useAISearchCounters;
